// @ts-ignore
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { MonolithImageSizeFragmentDoc } from '../useImageProps.generated';
export const ReviewsFragmentDoc = gql`
    fragment reviews on Review {
  id
  name
  comment
  date
  picture {
    id
    small: size(name: SMALL) {
      ...monolithImageSize
    }
    small_x2: size(name: SMALL_X2) {
      ...monolithImageSize
    }
  }
  rating
}
    ${MonolithImageSizeFragmentDoc}`;